module.exports = __webpack_public_path__ + "static/media/eight.892b3c3e.png";